import moment from "moment";

const DEFAULT_DATETIME_FORMAT = "YYYY-MM-DD HH:mm:ss";

interface FormatDateTimeOptions {
  date: string | Date;
  format?: string;
}

export class DateUtils {
  public static formatDateTime({ date, format = DEFAULT_DATETIME_FORMAT }: FormatDateTimeOptions): string {
    return moment(date).format(format);
  }
}
